import React from 'react';
import BonafideCertificate from "./BonafideCertificate"

const Bonafide = () => {
  return (
    <div>
      <BonafideCertificate
                studentName="John Doe"
                className="10th Grade"
                admissionDate="June 1, 2022"
                currentDate="October 1, 2024"
                purpose="Applying for Scholarship"
                // headName="Dr. Emily White"
                // address="123 Main Street, City, State, ZIP"
            />
    </div>
  )
}

export default Bonafide
